import styled from 'styled-components';
import { mobileBreakpoint } from './mobileBreakpoint';
import Celebration from 'src/assets/components/Celebration';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 100vh;
  h6 {
    font-weight: 600;
    font-size: 18px;
    color: ${props => props.theme.main.primary};
    margin-bottom: 1em;
  }
  p {
    font-size: 16px;
    font-weight: 400;
    color: ${props => props.theme.main.primary};
    margin: 0;
    padding: 0;
    @media ${mobileBreakpoint.mobile} {
      width: 65vw;
    }
    strong {
      font-weight: 700;
    }
  }
  svg {
    margin-bottom: 1em;
  }
`;

type Props = {
  advisorInfo: any;
};

function Conclusion({ advisorInfo }: Props) {
  return (
    <Wrapper>
      <Celebration />
      <h6>Thank you for filling this out!</h6>
      <p>
        Your financial advisor
        <strong>
          {advisorInfo?.firstName ? ', ' + advisorInfo?.firstName + ', ' : ''}
        </strong>
        will keep you posted.
      </p>
    </Wrapper>
  );
}

export default Conclusion;
